var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',{staticClass:"image",attrs:{"src":_vm.profileImage,"max-width":this.width},on:{"error":_vm.onImgError}})
}
var staticRenderFns = []

export { render, staticRenderFns }